import { Link } from "react-router-dom";
import { Phone } from "lucide-react";

export default function SiteFooter({ variant = "public" }) {
  const showLinks = variant !== "interne";
  const showCgv = variant === "public";
  return (
    <footer data-testid="preregistration-footer" className="">
      <div className="bg-white pb-8 pt-8">
        <div className="mx-auto max-w-6xl px-6 text-center">
          {showLinks && (
            <>
              <a
                href="tel:+33189708417"
                aria-label="Appelez-nous : +33 1 89 70 84 17"
                data-testid="preregistration-footer-tel"
                className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-[#2b46c4] shadow-[0_10px_20px_-8px_rgba(43,70,196,0.6)] transition-all duration-200 hover:scale-110"
              >
                <Phone className="h-4 w-4 text-white" />
              </a>
              <nav className="mt-5 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-[13px] font-normal text-[#717171] sm:gap-x-5">
              <Link
                to="/contact"
                className="whitespace-nowrap font-semibold text-[#2b46c4] transition-colors duration-200 hover:text-[#1e3299]"
                data-testid="preregistration-footer-contact-link"
              >
                Formulaire de contact
              </Link>
              <Link
                to="/faq"
                className="whitespace-nowrap font-semibold text-[#2b46c4] transition-colors duration-200 hover:text-[#1e3299]"
                data-testid="preregistration-footer-faq-link"
              >
                FAQ
              </Link>
              {showCgv && (
                <Link
                  to="/cgv"
                  className="whitespace-nowrap transition-colors duration-200 hover:text-[#2E4A7D]"
                  data-testid="preregistration-footer-cgv-link"
                >
                  Conditions Générales Contractuelles
                </Link>
              )}
              <Link
                to="/politique-de-confidentialite"
                className="whitespace-nowrap transition-colors duration-200 hover:text-[#2E4A7D]"
                data-testid="preregistration-footer-privacy-link"
              >
                Politique de confidentialité
              </Link>
              <Link
                to="/mentions-legales"
                className="whitespace-nowrap transition-colors duration-200 hover:text-[#2E4A7D]"
                data-testid="preregistration-footer-legal-link"
              >
                Mentions Légales
              </Link>
              <Link to="/bibliotheque" data-testid="preregistration-footer-bibliotheque-link" className="whitespace-nowrap font-semibold text-[#2b46c4] transition-colors duration-200 hover:text-[#1e3299]">
                Bibliothèque de documents
              </Link>
            </nav>
            </>
          )}
        </div>
      </div>
      <div className="fixed inset-x-0 bottom-0 z-40 border-t border-slate-200 bg-[#f8f8f8] py-2">
        <p className="text-center text-[9.5px] font-normal uppercase text-[#374151]" data-testid="preregistration-footer-copyright">
          © {new Date().getFullYear()} PassproFrance - Maak France - Tous droits réservés
        </p>
      </div>
      <div aria-hidden="true" className="h-10" />
    </footer>
  );
}
